import React, { useEffect, useMemo, useState } from 'react'
import { calculateAge, dateFormat } from '../../../../components/commonClass/CommonValidation';
import { flightDateFormat, getCabinType, getGenderTypeFlight } from '../bookingUtils';
import { CustomModal } from '../../../../customControl/CustomModal';

const FlightBookingDetailPopup = (props: any) => {
    const { flightData, show, setShow, activeTab } = props;
    const [filghtDetails, setFilghtDetails] = useState<any>({})
    const closeModal = () => {
        setShow(false)
    }

    useEffect(() => {
        let cloneFlight = { ...flightData }
        if (activeTab === 5) {
            const groupedFlights = flightData?.response?.flightItinerary?.segments?.length > 0 ? Object.values(
                flightData?.response?.flightItinerary?.segments?.reduce((acc: any, curr: any) => {
                    const key = curr?.tripIndicator;
                    if (!acc[key]) acc[key] = [];
                    acc[key]?.push(curr);
                    return acc;
                }, {})
            ) : [];

            cloneFlight = { ...cloneFlight, requestSegmentList: groupedFlights }
        }
        setFilghtDetails(cloneFlight)
    }, [flightData])



    const modlabodyfilter = () => {
        return (
            activeTab !== 5 ?
                <div className="modal-body px-0">
                    {flightData?.response?.flightItinerary?.segments?.map((obj: any, mainindex: number) => (
                        <div className={`${mainindex > 0 ? 'mt-5' : ''}`}>
                            <div className="label_title">
                                Booking Details
                            </div>

                            <div className="py-2 px-1">
                                <table className='booking_detail_table w-100 text-center'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className='fw-bold'> PNR No. </div>
                                            </td>
                                            <td>
                                                <div className='fw-bold text-muted'> {flightData?.response?.flightItinerary?.pnr} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking ID </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightData?.BookingNo} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Ref ID </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightData?.response?.flightItinerary?.bookingId} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Supplier </div>
                                            </td>
                                            <td>
                                                <div className=''> TBO </div>
                                            </td>
                                        </tr>

                                        <tr>

                                            <td>
                                                <div className='fw-bold'> Dep-Arr. </div>
                                            </td>
                                            <td>
                                                <div className='fw-bold text-muted'> {obj?.origin?.airport?.cityCode} - {obj?.destination?.airport?.cityCode} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking Date </div>
                                            </td>
                                            <td>
                                                <div className=''> {dateFormat(flightData?.CreatedDate)} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Departure Date & Time </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightDateFormat(obj?.origin?.depTime)} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Arrival Date & Time </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightDateFormat(obj?.destination?.arrTime)} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Airline name </div>
                                            </td>
                                            <td>
                                                <div className=''> {obj?.airline?.airlineName} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking Class </div>
                                            </td>
                                            <td>
                                                <div className=''> {getCabinType(obj?.cabinClass)} </div>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            <div className="label_title mx-1">
                                Passenger Details
                            </div>

                            <div className="py-1 px-1">
                                <div className='overflow-auto'>
                                    <table className='Passanger_detail_table w-100 text-center fs_14' style={{ wordBreak: 'break-word' }}>
                                        <thead>
                                            <tr>
                                                <th>P. No</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Gender</th>
                                                <th>Age</th>
                                                <th>Contact No.</th>
                                                <th>Email ID</th>
                                                {activeTab !== 5 &&
                                                    <>
                                                        <th>Seat</th>
                                                        <th>Baggage</th>
                                                        <th>Meal</th>
                                                        <th>Special Services</th>
                                                    </>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                flightData?.response?.flightItinerary?.passenger?.filter((pax: any) => {
                                                    const match = pax?.partialCancelDetails?.find(
                                                        (pc: any) => pc?.tripIndicator === obj?.tripIndicator
                                                    );
                                                    return !match || match?.isPartiallyCancel === false;
                                                })?.map((passenger: any, index: number) => {
                                                    return (
                                                        <tr key={`${passenger?.firstName}${index}`} >
                                                            <td style={{ minWidth: '50px' }}> <div> {index + 1} </div> </td>
                                                            <td style={{ minWidth: '100px' }}> <div> {passenger?.firstName} </div> </td>
                                                            <td style={{ minWidth: '100px' }}> <div> {passenger?.lastName} </div> </td>
                                                            <td style={{ minWidth: '80px' }}> <div> {getGenderTypeFlight(passenger?.gender)} </div> </td>
                                                            <td style={{ minWidth: '50px' }}> <div> {calculateAge(passenger?.dateOfBirth)} </div> </td>
                                                            <td style={{ minWidth: '110px' }}> <div> {passenger?.contactNo} </div> </td>
                                                            <td style={{ minWidth: '150px' }}> <div> {passenger?.email} </div> </td>
                                                            {activeTab !== 5 &&
                                                                <>
                                                                    <td style={{ minWidth: '50px' }}> <div> {passenger?.seatDynamic?.[mainindex]?.code || "N/A"} </div> </td>
                                                                    <td style={{ minWidth: '70px' }}> <div> {`${passenger?.baggage?.[mainindex]?.weight ? `${passenger?.baggage?.[mainindex]?.weight} Kg` : "N/A"}`} </div> </td>
                                                                    <td style={{ minWidth: '150px' }}> <div> {passenger?.mealDynamic?.[mainindex]?.airlineDescription || "N/A"} </div> </td>
                                                                    <td style={{ minWidth: '50px' }}> <div> {passenger?.segmentAdditionalInfo?.[mainindex]?.specialService || "N/A"} </div> </td>
                                                                </>
                                                            }
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                :
                <div className="modal-body px-0">
                    {filghtDetails?.requestSegmentList?.map((obj: any, mainindex: number) => (
                        <div className={`${mainindex > 0 ? 'mt-5' : ''}`}>
                            <div className="label_title">
                                Booking Details
                            </div>

                            <div className="py-2 px-1">
                                <table className='booking_detail_table w-100 text-center'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className='fw-bold'> PNR No. </div>
                                            </td>
                                            <td>
                                                <div className='fw-bold text-muted'> {flightData?.response?.flightItinerary?.pnr} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking ID </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightData?.BookingNo} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Ref ID </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightData?.response?.flightItinerary?.bookingId} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Supplier </div>
                                            </td>
                                            <td>
                                                <div className=''> TBO </div>
                                            </td>
                                        </tr>

                                        <tr>

                                            <td>
                                                <div className='fw-bold'> Dep-Arr. </div>
                                            </td>
                                            <td>
                                                <div className='fw-bold text-muted'> {obj?.[0]?.origin?.airport?.cityCode} - {obj?.[obj?.length - 1]?.destination?.airport?.cityCode} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking Date </div>
                                            </td>
                                            <td>
                                                <div className=''> {dateFormat(flightData?.CreatedDate)} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Departure Date & Time </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightDateFormat(obj?.[0]?.origin?.depTime)} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Arrival Date & Time </div>
                                            </td>
                                            <td>
                                                <div className=''> {flightDateFormat(obj?.[obj?.length - 1]?.destination?.arrTime)} </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='fw-bold'> Airline name </div>
                                            </td>
                                            <td>
                                                <div className=''> {obj?.map((el: any, index: any) => ((obj?.length - 1) === index) ? el?.airline?.airlineName : el?.airline?.airlineName + '/')} </div>
                                            </td>
                                            <td className='p-0' >
                                                <div style={{ backgroundColor: '#0777A9' }} ></div>
                                            </td>
                                            <td>
                                                <div className='fw-bold'> Booking Class </div>
                                            </td>
                                            <td>
                                                <div className=''> {getCabinType(obj?.[0]?.cabinClass)} </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="label_title mx-1">
                                Passenger Details
                            </div>

                            <div className="py-1 px-1">
                                <div className='overflow-auto'>
                                    <table className='Passanger_detail_table w-100 text-center fs_14' style={{ wordBreak: 'break-word' }}>
                                        <thead>
                                            <tr>
                                                <th>P. No</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Gender</th>
                                                <th>Age</th>
                                                <th>Contact No.</th>
                                                <th>Email ID</th>
                                                <th>Refund</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                flightData?.response?.flightItinerary?.passenger?.filter((prev: any) => prev?.partialCancelDetails?.length > 0 && prev?.partialCancelDetails?.filter((prev: any) => prev?.tripIndicator === obj?.[0]?.tripIndicator)?.length > 0)?.map((passenger: any, index: number) => {
                                                    return (
                                                        <tr key={`${passenger?.firstName}${index}`} >
                                                            <td style={{ minWidth: '50px' }}> <div> {index + 1} </div> </td>
                                                            <td style={{ minWidth: '100px' }}> <div> {passenger?.firstName} </div> </td>
                                                            <td style={{ minWidth: '100px' }}> <div> {passenger?.lastName} </div> </td>
                                                            <td style={{ minWidth: '80px' }}> <div> {getGenderTypeFlight(passenger?.gender)} </div> </td>
                                                            <td style={{ minWidth: '50px' }}> <div> {calculateAge(passenger?.dateOfBirth)} </div> </td>
                                                            <td style={{ minWidth: '110px' }}> <div> {passenger?.contactNo} </div> </td>
                                                            <td style={{ minWidth: '150px' }}> <div> {passenger?.email} </div> </td>
                                                            <td style={{ minWidth: '50px' }}> <div> {passenger?.partialCancelDetails?.find((prev: any) => prev?.tripIndicator === obj?.[0]?.tripIndicator)?.refundAmount ?? "-"} </div> </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
        )
    }


    return (
        <>
            <CustomModal
                {...props}
                show={show}
                size='xl'
                onHide={() => setShow(false)}
                modaltitle='Flights Detail'
                modalbody={modlabodyfilter}
                modalfooter=''
            />
        </>
    )
}

export default FlightBookingDetailPopup
